export default {

    uploadImage(event) {
        return new Promise((resolve, reject) => {
            let files = event.target.files || event.dataTransfer.files;
            if (!files.length) {
                reject();
            }

            let file = files[0];

            if (file.size > 1024 * 1024 * 5) {
                alert('Файл не может быть больше 5 Мб');
                reject();
            }

            let reader = new FileReader();

            reader.onload = (e) => {
                let base64Content = e.target.result;
                resolve({
                    name: file.name,
                    type: file.type,
                    content: base64Content
                });
            };

            reader.readAsDataURL(file);

            setTimeout(() => reject(), 2000);
        });
    }

}